import { Link } from 'react-router-dom';

interface AnimeCardProps {
  id: number;
  title: string;
  slug: string;
  category: string;
  rating: number;
  views: string;
  episodes: string;
  cover: string;
  tags: string[];
}

export default function AnimeCard({ id, title, slug, rating, views, episodes, cover, tags }: AnimeCardProps) {
  return (
    <Link
      to={`/anime/${id}`}
      className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          title={`${title} - 91动漫高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-black/60 text-accent-400 text-xs font-semibold">
          <i className="ri-star-fill text-[10px]"></i>
          {rating}
        </div>
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-white text-xs font-medium">
          {episodes}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <span className="text-white text-sm font-medium">立即观看 <i className="ri-arrow-right-line ml-1"></i></span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1.5">
          {title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
          <span><i className="ri-eye-line mr-0.5"></i>{views}</span>
        </div>
        <div className="flex flex-wrap gap-1">
          {tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 rounded text-[10px] bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}